
import React from 'react';
import { IconProps } from '../../types/types';

const NewContactIcon: React.FC<IconProps> = ({ size = '24px', color = 'white' }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0026 9.99984C12.3038 9.99984 14.1693 8.13436 14.1693 5.83317C14.1693 3.53198 12.3038 1.6665 10.0026 1.6665C7.70142 1.6665 5.83594 3.53198 5.83594 5.83317C5.83594 8.13436 7.70142 9.99984 10.0026 9.99984Z" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.1565 18.3333C17.1565 15.1083 13.9482 12.5 9.99817 12.5C6.04817 12.5 2.83984 15.1083 2.83984 18.3333" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default NewContactIcon;
